import React, { useState } from 'react';
import { Input } from '@this/components/shared/ui/inputs/input';

export type InlineEditNumberCellProps = {
  value: number | null;
  allowNull: boolean;
  placeholder?: string;
  disabled?: boolean;
  onSubmit: (next: number | null) => Promise<boolean>;
};

const wrapperStyle: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: '4px'
};

const inputStyle: React.CSSProperties = {
  width: '100px'
};

const InlineEditNumberCell = ({
  value,
  allowNull,
  placeholder,
  disabled,
  onSubmit
}: InlineEditNumberCellProps) => {
  const [editing, setEditing] = useState<string | undefined>(undefined);

  const displayValue = editing !== undefined ? editing : value?.toString() ?? '';

  const handleSubmit = async () => {
    if (editing === undefined) return;

    if (editing === '') {
      if (allowNull) {
        const ok = await onSubmit(null);
        if (ok) setEditing(undefined);
      } else {
        setEditing(undefined);
      }
      return;
    }

    const parsed = parseInt(editing, 10);
    if (isNaN(parsed)) {
      setEditing(undefined);
      return;
    }

    const ok = await onSubmit(parsed);
    if (ok) setEditing(undefined);
  };

  return (
    <div style={wrapperStyle}>
      <Input
        type="number"
        size="small"
        placeholder={placeholder}
        style={inputStyle}
        value={displayValue}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          const v = e?.target?.value;
          if (v === undefined) return;
          setEditing(v);
        }}
        onBlur={handleSubmit}
        onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
          if (e.key === 'Enter') handleSubmit();
        }}
        disabled={disabled}
      />
    </div>
  );
};

export default InlineEditNumberCell;
